import { render } from "./ToolTipStandartDescription.vue?vue&type=template&id=df08e5ec&scoped=true&ts=true"
import script from "./ToolTipStandartDescription.vue?vue&type=script&lang=ts"
export * from "./ToolTipStandartDescription.vue?vue&type=script&lang=ts"

import "./ToolTipStandartDescription.vue?vue&type=style&index=0&id=df08e5ec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df08e5ec"]])

export default __exports__